<script>
import Settings from '@/components/meta/Settings'

import StyledButton from '@/components/snippets/StyledButton'

export default {
  name: 'ViewSettings',

  components: {
    Settings,
    StyledButton
  }
}
</script>

<template>
  <div class="c-view-settings">
    <div class="c-view-settings-content">

      <settings />

      <div class="c-view-settings-actions">

        <styled-button :to="{ name: 'splash' }">
          Quit to title screen
        </styled-button>

      </div>

    </div>
  </div>
</template>

<style lang="scss">

.c-view-settings {
  @include fill-relative;
}

.c-view-settings-content {
  @include keep-full-center;
  width: $width-content-tight;
  max-width: 100%;
}

.c-view-settings-actions {
  @include push-top;
}

</style>
